module.exports = __webpack_public_path__ + "media/puzzle4.2a85db47.mp3";